import Banner from 'app/components/partials/banner';
import CategorySelector from 'app/components/partials/category-selector';
import ContentBlocks from 'app/components/content-blocks/index';
import FilterStories from 'app/components/partials/filter-stories.container';
import formatContent from 'app/utilities/format-content';
import { LAYOUT } from 'app/utilities/news-listing';
import PropTypes from 'prop-types';
import SubcategoryTiles from 'app/components/partials/subcategory-tiles';
import React, { Component } from 'react';

/**
 * Level 1 news category page, e.g. /news/conservation
 */
class NewsCategory extends Component {
    render() {
        const { activeCategories, id, listingPage, newsCategories, newsSubCategories } = this.props;

        const {
            blocks = [],
            intro_content: intro,
            name: title,
            highlighted_information: highlight,
            main_images: images = [],
            short_description: description,
            slug
        } = this.props.data;

        return (
            <div className="page || news-category-view">
                <Banner
                    title={title}
                    introduction={description}
                    highlight={highlight}
                    images={images} />
                {/* Same top row as the news landing page, with this category active */}
                <CategorySelector ariaLabel="News categories" categories={newsCategories} />
                {/* Editor HTML, so it can link out to the animal and subcategory
                    pages behind the listing. A row of its own between the two
                    rows of navigation: it introduces the category rather than
                    any one of the subcategories under it. */}
                {intro && (
                    <div className="news-category-intro">
                        <div className="constrain-width large">
                            <div
                                className="rich-editor-content"
                                dangerouslySetInnerHTML={{ __html: formatContent(intro) }} />
                        </div>
                    </div>
                )}
                <SubcategoryTiles
                    ariaLabel={`${title} subcategories`}
                    basePath={`/news/${slug}`}
                    categories={newsSubCategories} />
                {/* Unticked shows this category's news, which the API expands to
                    include its subcategories */}
                <FilterStories
                    activeCategories={activeCategories}
                    layout={LAYOUT.GRID}
                    listingPage={listingPage}
                    categories={newsSubCategories}
                    pageCategoryId={id} />
                <ContentBlocks data={blocks} hasListing={true} />
            </div>
        );
    }
}

NewsCategory.propTypes = {
    activeCategories: PropTypes.array,
    listingPage: PropTypes.number,
    data: PropTypes.object.isRequired,
    id: PropTypes.string,
    newsCategories: PropTypes.array,
    newsSubCategories: PropTypes.array
};

export default NewsCategory;
